export default __webpack_public_path__ + "static/media/momo2.f8ddd66e.jpg";